"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const antd_1 = require("antd");
const FormItem_1 = require("antd/lib/form/FormItem");
const helpers_1 = require("../helpers");
const models_1 = require("../models");
class ReachTableFilterComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            collapsible: false
        };
        this.updateFilter = (filter) => {
            this.props.onFilterSelect(Object.assign({}, this.props.filter, filter));
        };
        this.handleSearch = (event) => {
            event.preventDefault();
            this.props.form.validateFields((err, values) => {
                this.updateFilter(values);
            });
        };
        this.handleReset = () => {
            this.props.form.resetFields();
            this.props.form.validateFields((err, values) => {
                this.updateFilter(values);
            });
        };
        this.handleChanges = (event) => {
            setTimeout(this.filtersValidate, 0);
        };
        this.filtersValidate = () => {
            this.props.form.validateFields((err, values) => {
                this.updateFilter(values);
            });
        };
        this.toggle = () => {
            const { expanded } = this.state;
            this.setState({ expanded: !expanded });
        };
        this.state.collapsible = !this.props.filters.every(item => item.shownByDefault);
    }
    render() {
        const { style, bodyStyle } = this.props;
        return (React.createElement(antd_1.Card, { style: style, bordered: false, bodyStyle: bodyStyle },
            React.createElement(antd_1.Form, { className: "ant-table-filter", onSubmit: this.handleSearch },
                React.createElement(antd_1.Row, { gutter: 24 }, this.getFields()))));
    }
    getFields() {
        const { filters } = this.props;
        const { expanded } = this.state;
        const children = [];
        filters.forEach((item, i) => {
            if (!(expanded || item.shownByDefault)) {
                return;
            }
            let filterComponent;
            switch (item.type) {
                case models_1.TableFilterTypes.Text:
                    filterComponent = this.getTextFilter(item);
                    break;
                case models_1.TableFilterTypes.Select:
                    filterComponent = this.getSelectFilter(item);
                    break;
                case models_1.TableFilterTypes.Flag:
                    filterComponent = this.getFlagFilter(item);
                    break;
                case models_1.TableFilterTypes.Date:
                    filterComponent = this.getDateFilter(item);
                    break;
                case models_1.TableFilterTypes.DateRange:
                    filterComponent = this.getDateRangeFilter(item);
                    break;
                default:
                    helpers_1.assertUnreachable(item.type);
            }
            children.push(React.createElement(antd_1.Col, { span: item.styleOptions.span, key: i }, filterComponent));
        });
        return children;
    }
    getDateFilter(item) {
        const { getFieldDecorator } = this.props.form;
        return (React.createElement(FormItem_1.default, { label: !item.styleOptions.withoutLabel && item.label }, getFieldDecorator(item.name, {})(React.createElement(antd_1.DatePicker, { style: { width: '100%' }, format: 'YYYY-MM-DD' }))));
    }
    getTextFilter(item) {
        const { getFieldDecorator } = this.props.form;
        return (React.createElement(FormItem_1.default, { label: !item.styleOptions.withoutLabel && item.label }, getFieldDecorator(item.name, {})(React.createElement(antd_1.Input, { placeholder: item.label }))));
    }
    getDateRangeFilter(item) {
        const { getFieldDecorator } = this.props.form;
        return (React.createElement(FormItem_1.default, { label: !item.styleOptions.withoutLabel && item.label }, getFieldDecorator(item.name, {})(React.createElement(antd_1.DatePicker.RangePicker, { style: { width: '100%' } }))));
    }
    getSelectFilter(item) {
        const { getFieldDecorator } = this.props.form;
        const options = item.options.map(item => (React.createElement(antd_1.Select.Option, { key: item.value, value: item.value }, item.label)));
        return (React.createElement(FormItem_1.default, { label: !item.styleOptions.withoutLabel && item.label, className: "ant-select-fix" }, getFieldDecorator(item.name, {})(React.createElement(antd_1.Select, { dropdownMatchSelectWidth: false, placeholder: item.label, allowClear: true, style: { width: '100%' }, onChange: this.handleChanges }, options))));
    }
    getFlagFilter(item) {
        const { getFieldDecorator } = this.props.form;
        return (React.createElement(FormItem_1.default, null, getFieldDecorator(item.name, {
            valuePropName: 'checked'
        })(React.createElement(antd_1.Checkbox, null, item.label))));
    }
}
exports.ReachTableFilter = antd_1.Form.create({
    mapPropsToFields(props) {
        const { filter } = props;
        return helpers_1.AntdFormHelper.mapValidationToFields(filter);
    }
})(ReachTableFilterComponent);
//# sourceMappingURL=ReachTableFilter.js.map